const recurringTaskOptions = {
  NONE: "none",
  DAILY: "daily",
  WEEKLY: "weekly",
  MONTHLY: "monthly",
  PLANNED: "planned",
};

module.exports = { recurringTaskOptions };
